module.exports = __webpack_public_path__ + "img/electric_use_selected.5bd781e7.svg";